import type { Entry } from "@/shared/types/entries";
import type { GroupOptions } from "@/v2/hooks/actions/group";
import type { MergeOptions } from "@/v2/hooks/actions/merge";
import { distinctValues, unitsCandidates } from "@/v2/lib/reconcileSources";

export interface EntryBulkOptionsContext {
	entries: Entry[];
	client: string | null;
}

export interface GroupBulkOptionsContext extends EntryBulkOptionsContext {
	includeUnits: boolean;
}

export function createGroupOptions({
	entries,
	client,
	includeUnits,
}: GroupBulkOptionsContext): GroupOptions {
	const dates = distinctValues(entries, "date");
	const matterIds = distinctValues(entries, "matter_id");
	const taskCodes = distinctValues(entries, "task");
	const activityCodes = distinctValues(entries, "activity");
	const { sumUnits } = unitsCandidates(entries, client);

	return {
		date: String(dates[0] ?? entries[0].date),
		matterId: matterIds[0] ? String(matterIds[0]) : null,
		taskId: taskCodes[0] ? String(taskCodes[0]) : null,
		activityId: activityCodes[0] ? String(activityCodes[0]) : null,
		unitsSeconds: sumUnits.snappedSeconds,
		includeUnits,
	};
}

export function createMergeOptions({
	entries,
	client,
}: EntryBulkOptionsContext): MergeOptions {
	const dates = distinctValues(entries, "date");
	const matterIds = distinctValues(entries, "matter_id");
	const taskCodes = distinctValues(entries, "task");
	const activityCodes = distinctValues(entries, "activity");
	const { sumUnits } = unitsCandidates(entries, client);

	return {
		date: String(dates[0] ?? entries[0].date),
		matterId: matterIds[0] ? String(matterIds[0]) : null,
		taskId: taskCodes[0] ? String(taskCodes[0]) : null,
		activityId: activityCodes[0] ? String(activityCodes[0]) : null,
		unitsSeconds: sumUnits.snappedSeconds,
	};
}
